export const information = {
  title: ["一起露營吧", "海邊野餐吧"],
  text: [
    "太好了，這個週末是晴朗的一天！全家人打算要一起去露營，要準備些什麼才好呢～",
    "週末是絕美的日子，我們一家決定一起去海邊野餐。",
  ],
};
